import { Checkbox, FormControl, FormControlLabel } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { Label } from './TextField';
import styles from './Inputs.module.css';
import DisplayErrorMessages from './DisplayErrorMessages';

function Checkboxes(props) {
  const {
    formData,
    inputName,
    error = false,
    label,
    options,
    required = false,
    onChange = () => {},
    viewMode = false,
    errorText = null,
    disabled = false,
  } = props;

  if (!viewMode) {
    return (
      <FormControl variant="standard" component="fieldset" required={required}>
        <Label required={required} label={label} error={error} />

        {options.map((checkbox) => (
          <FormControlLabel
            label={checkbox.label}
            key={checkbox.value}
            disabled={disabled}
            control={
              <Checkbox
                color="primary"
                checked={formData[inputName].includes(checkbox.value)}
                onChange={(e) => onChange(inputName, e.target.value)}
                disabled={disabled}
                name={inputName}
                value={checkbox.value}
              />
            }
          />
        ))}
        <DisplayErrorMessages error={error} errorText={errorText} />
      </FormControl>
    );
  }
  return (
    <div className={styles.twoColumnLayout}>
      <div className={styles.labelColumn}>{label}</div>
      <div className={styles.valueColumn}>
        {formData[inputName].map((value) => {
          const option = options.find((opt) => opt.value === value);
          return (
            <div key={value} className={styles.tag}>
              {option.label}
            </div>
          );
        })}
      </div>
    </div>
  );
}

Checkboxes.propTypes = {
  formData: PropTypes.shape({}).isRequired,
  inputName: PropTypes.string.isRequired,
  error: PropTypes.bool,
  errorText: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  viewMode: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default Checkboxes;
